import { AbstractHandler } from '../../interfaces/handler.interface';
import { TokenSetupPayload } from '../../interfaces/host-message-payloads.types';

export class HostHandler extends AbstractHandler<TokenSetupPayload> {
  override handle(request: TokenSetupPayload): string | null {
    if (request.host) {
      return request.host;
    }

    return super.handle(request);
  }
}
